import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import Routing from "./routes/Routing";
import {ConfirmContextProvider} from "../src/contextprovider/confirmcontextprovider";
import { PermissionProvider } from './context/permissionContext';


import 'bootstrap/dist/css/bootstrap.min.css';
ReactDOM.render(
    <React.StrictMode>
        <PermissionProvider>
            <ConfirmContextProvider>
            <Routing />
            </ConfirmContextProvider>
            </PermissionProvider>
    </React.StrictMode>,
    document.getElementById("root")
);